import React from 'react'

const SuspiciousAccounts = () => {
  return (
    <div>SuspiciousAccounts</div>
  )
}

export default SuspiciousAccounts